// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-page {
  background: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.dashboard-page-content {
  display: flex;
  width: 100%;
  gap: 36px;
}

.dashboard-page h2 {
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 12px;
}

.dashboard-page h3 {
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 24px;
}

.dashboard-page p {
  font-size: 16px;
  color: #718096;
}

/* institutionStaff - Personel paneli */
.staff-page-error {
  color: #d32f2f;
  background: #ffebee;
  padding: 1rem;
  border-radius: 8px;
}

.staff-subtitle {
  margin-bottom: 1.5rem;
  color: #718096;
}

.staff-empty {
  color: #718096;
}

.staff-department-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
}

.staff-department-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  padding: 1.25rem;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;
}

.staff-department-card:hover {
  border-color: #4a90d9;
  box-shadow: 0 4px 12px rgba(74, 144, 217, 0.15);
  transform: translateY(-2px);
}

.staff-department-card-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 0.35rem;
}

.staff-department-card-branch {
  font-size: 0.875rem;
  color: #718096;
}

/* Seçili departman ekranı */
.staff-department-header {
  margin-bottom: 1.5rem;
}

.staff-back-btn {
  padding: 0.5rem 0;
  margin-bottom: 0.5rem;
  font-size: 0.9375rem;
  color: #4a90d9;
  background: none;
  border: none;
  cursor: pointer;
}

.staff-back-btn:hover {
  text-decoration: underline;
}

.staff-department-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.25rem 0;
}

.staff-department-branch {
  font-size: 0.9375rem;
  color: #718096;
  margin: 0;
}

.staff-department-content {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.staff-main-area {
  flex: 1;
  min-width: 0;
}

.staff-accept-section {
  margin-bottom: 1.5rem;
}

.staff-accept-btn {
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  background: #4a90d9;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.staff-accept-btn:hover:not(:disabled) {
  background: #357abd;
}

.staff-accept-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.staff-error {
  margin-top: 0.5rem;
  font-size: 0.875rem;
  color: #d32f2f;
}

.staff-current-appointment {
  margin-top: 1rem;
}

.staff-current-appointment h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 0.75rem;
}

.staff-appointment-card {
  padding: 1rem;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 8px;
  font-size: 0.9375rem;
}

.staff-appointment-card p {
  margin: 0.25rem 0;
  color: #1a202c;
}

.staff-complete-actions {
  margin-top: 1rem;
}

.staff-complete-btn {
  padding: 0.6rem 1.25rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #fff;
  background: #22c55e;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.staff-complete-btn:hover:not(:disabled) {
  background: #16a34a;
}

.staff-complete-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Sırayı tamamla modal */
.staff-complete-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.staff-complete-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  min-width: 360px;
  max-width: 90vw;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.staff-complete-modal h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  color: #1a202c;
}

.staff-complete-modal-hint {
  font-size: 0.875rem;
  color: #718096;
  margin: 0 0 1rem 0;
}

.staff-complete-notes {
  width: 100%;
  box-sizing: border-box;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9375rem;
  font-family: inherit;
  resize: vertical;
  margin-bottom: 0.25rem;
}

.staff-complete-notes:focus {
  outline: none;
  border-color: #4a90d9;
}

.staff-complete-notes-count {
  display: block;
  font-size: 0.75rem;
  color: #718096;
  margin-bottom: 1rem;
}

.staff-complete-modal-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.staff-complete-modal-cancel {
  padding: 0.5rem 1rem;
  font-size: 0.9375rem;
  color: #4a5568;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.staff-complete-modal-cancel:hover {
  background: #edf2f7;
}

.staff-complete-modal-submit {
  padding: 0.5rem 1rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #fff;
  background: #22c55e;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.staff-complete-modal-submit:hover:not(:disabled) {
  background: #16a34a;
}

.staff-complete-modal-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Sağ panel - Sıra bekleyenler */
.staff-queue-panel {
  width: 320px;
  flex-shrink: 0;
  padding: 1.25rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.staff-queue-panel h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 1rem 0;
}

.staff-queue-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.staff-queue-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.9375rem;
}

.staff-queue-number {
  font-weight: 600;
  color: #4a90d9;
  min-width: 2rem;
}

.staff-queue-phone {
  margin-left: auto;
  font-size: 0.875rem;
  color: #718096;
}

.staff-queue-empty {
  font-size: 0.9375rem;
  color: #718096;
  margin: 0;
}

/* Kabul edilen randevu - kartlar listesi */
.staff-in-progress-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}



`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/DashboardPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX","sourcesContent":[".dashboard-page {\n  background: white;\n  border-radius: 12px;\n  padding: 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.dashboard-page-content {\n  display: flex;\n  width: 100%;\n  gap: 36px;\n}\n\n.dashboard-page h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 12px;\n}\n\n.dashboard-page h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 24px;\n}\n\n.dashboard-page p {\n  font-size: 16px;\n  color: #718096;\n}\n\n/* institutionStaff - Personel paneli */\n.staff-page-error {\n  color: #d32f2f;\n  background: #ffebee;\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.staff-subtitle {\n  margin-bottom: 1.5rem;\n  color: #718096;\n}\n\n.staff-empty {\n  color: #718096;\n}\n\n.staff-department-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.staff-department-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  padding: 1.25rem;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n  cursor: pointer;\n  transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;\n}\n\n.staff-department-card:hover {\n  border-color: #4a90d9;\n  box-shadow: 0 4px 12px rgba(74, 144, 217, 0.15);\n  transform: translateY(-2px);\n}\n\n.staff-department-card-name {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #1a202c;\n  margin-bottom: 0.35rem;\n}\n\n.staff-department-card-branch {\n  font-size: 0.875rem;\n  color: #718096;\n}\n\n/* Seçili departman ekranı */\n.staff-department-header {\n  margin-bottom: 1.5rem;\n}\n\n.staff-back-btn {\n  padding: 0.5rem 0;\n  margin-bottom: 0.5rem;\n  font-size: 0.9375rem;\n  color: #4a90d9;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.staff-back-btn:hover {\n  text-decoration: underline;\n}\n\n.staff-department-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 0.25rem 0;\n}\n\n.staff-department-branch {\n  font-size: 0.9375rem;\n  color: #718096;\n  margin: 0;\n}\n\n.staff-department-content {\n  display: flex;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.staff-main-area {\n  flex: 1;\n  min-width: 0;\n}\n\n.staff-accept-section {\n  margin-bottom: 1.5rem;\n}\n\n.staff-accept-btn {\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #fff;\n  background: #4a90d9;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.staff-accept-btn:hover:not(:disabled) {\n  background: #357abd;\n}\n\n.staff-accept-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.staff-error {\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n  color: #d32f2f;\n}\n\n.staff-current-appointment {\n  margin-top: 1rem;\n}\n\n.staff-current-appointment h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 0.75rem;\n}\n\n.staff-appointment-card {\n  padding: 1rem;\n  background: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 8px;\n  font-size: 0.9375rem;\n}\n\n.staff-appointment-card p {\n  margin: 0.25rem 0;\n  color: #1a202c;\n}\n\n.staff-complete-actions {\n  margin-top: 1rem;\n}\n\n.staff-complete-btn {\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #fff;\n  background: #22c55e;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.staff-complete-btn:hover:not(:disabled) {\n  background: #16a34a;\n}\n\n.staff-complete-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Sırayı tamamla modal */\n.staff-complete-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.staff-complete-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  min-width: 360px;\n  max-width: 90vw;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n}\n\n.staff-complete-modal h4 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n  color: #1a202c;\n}\n\n.staff-complete-modal-hint {\n  font-size: 0.875rem;\n  color: #718096;\n  margin: 0 0 1rem 0;\n}\n\n.staff-complete-notes {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.9375rem;\n  font-family: inherit;\n  resize: vertical;\n  margin-bottom: 0.25rem;\n}\n\n.staff-complete-notes:focus {\n  outline: none;\n  border-color: #4a90d9;\n}\n\n.staff-complete-notes-count {\n  display: block;\n  font-size: 0.75rem;\n  color: #718096;\n  margin-bottom: 1rem;\n}\n\n.staff-complete-modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.staff-complete-modal-cancel {\n  padding: 0.5rem 1rem;\n  font-size: 0.9375rem;\n  color: #4a5568;\n  background: #f7fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.staff-complete-modal-cancel:hover {\n  background: #edf2f7;\n}\n\n.staff-complete-modal-submit {\n  padding: 0.5rem 1rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #fff;\n  background: #22c55e;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.staff-complete-modal-submit:hover:not(:disabled) {\n  background: #16a34a;\n}\n\n.staff-complete-modal-submit:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Sağ panel - Sıra bekleyenler */\n.staff-queue-panel {\n  width: 320px;\n  flex-shrink: 0;\n  padding: 1.25rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.staff-queue-panel h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 1rem 0;\n}\n\n.staff-queue-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.staff-queue-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.9375rem;\n}\n\n.staff-queue-number {\n  font-weight: 600;\n  color: #4a90d9;\n  min-width: 2rem;\n}\n\n.staff-queue-phone {\n  margin-left: auto;\n  font-size: 0.875rem;\n  color: #718096;\n}\n\n.staff-queue-empty {\n  font-size: 0.9375rem;\n  color: #718096;\n  margin: 0;\n}\n\n/* Kabul edilen randevu - kartlar listesi */\n.staff-in-progress-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
